<template>
    <div class="content">
        <div class="cat">
            <div class="row">
                <div class="col-2 text-left">
                    <router-link v-if="this.previous_category_id"
                                 :to="{name:'menu.category.products', params:{id:this.previous_category_id}}"
                                 class="prev">
                        <i class="fa fa-chevron-left color"></i>
                    </router-link>
                </div>
                <div class="col-8">{{this.category_name}}</div>
                <div class="col-2 text-right">
                    <router-link v-if="this.next_category_id"
                                 :to="{name:'menu.category.products', params:{id:this.next_category_id}}"
                                 class="next">
                        <i class="fa fa-chevron-right color"></i>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="content-list">
            <inc-product-list :products="this.products" :category-id="this.$route.params.id"/>
        </div><!-- /.content-list -->
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {getProductsList} from '../../api/restaurant';
    import {getUsableProducts} from '../../libraries/utils';

    import IncProductList from './partials/IncProductList';

    export default {
        name: "Products",
        components: {IncProductList},
        data() {
            return {
                products: [],
                category_name: '',
                next_category_id: null,
                previous_category_id: null
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            }),
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('order', {
                order: state => state
            })
        },
        watch: {
            $route: function (to, from) {
                if (from.name === to.name) {
                    this.fetch();
                }
            },
            language: function () {
                this.fetch();
            }
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                getProductsList(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_menu: this.order.id_menu,
                    id_categoria: this.$route.params.id,
                    //configs
                    nome_categoria: true,
                    id_categoria_precedente: true,
                    id_categoria_successiva: true
                }).then((response) => {
                    this.products = getUsableProducts(response.prodotti, this.locale.id, this.order.type);
                    this.category_name = response.nome_categoria;
                    this.next_category_id = response.categoria_successiva;
                    this.previous_category_id = response.categoria_precedente;
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
